import Operation from './Operation';

export default class Addition extends Operation {
  cal (a, b) {
    a = Number(a || 0);
    b = Number(b || 0);
    return a + b;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Addition.js